import shared, { SHARED_PAGES } from "./shared";
import vbsus from "./vbsus";
import mx from "./mx";
import eds from "./eds";

/** @type {Record<string, import('./types').StorefrontTenantModule>} */
export const STOREFRONT_TENANTS = {
  vbsus,
  mx,
  eds,
};

/**
 * Resolve a storefront page component for the active tenant.
 * Falls back to shared defaults when a tenant has no override.
 *
 * @param {string | null | undefined} tenantKey
 * @param {import('./types').StorefrontPageKey} pageName
 */
export function resolveStorefrontPage(tenantKey, pageName) {
  const key = String(tenantKey || "")
    .trim()
    .toLowerCase();
  const tenant = STOREFRONT_TENANTS[key];
  return tenant?.pages?.[pageName] || SHARED_PAGES[pageName] || null;
}

export function getStorefrontTenantModule(tenantKey) {
  const key = String(tenantKey || "")
    .trim()
    .toLowerCase();
  return STOREFRONT_TENANTS[key] || null;
}

export function listStorefrontTenants() {
  return Object.values(STOREFRONT_TENANTS);
}

export { shared };
